import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FileUploadModule } from 'ng2-file-upload';

import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../../material.module';
import { FileUploadComponent } from './file-upload.component';

@NgModule({
  declarations: [FileUploadComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FileUploadModule,
    TranslateModule,
  ],
  providers: [],
  exports: [FileUploadComponent],
})
export class OdqFileUploadModule { }
